import { combineReducers } from 'redux'
import {
	bgBlackListSlice,
	bgDocumentSlice,
	bgRequestSlice,
	bgLeadSlice,
	bgSignatorySlice,
} from './slice'

export * from './slice'
export * from './selectors'
export * from './saga'

export const requests = combineReducers({
	[bgBlackListSlice.name]: bgBlackListSlice.reducer,
	[bgDocumentSlice.name]: bgDocumentSlice.reducer,
	[bgRequestSlice.name]: bgRequestSlice.reducer,
	[bgLeadSlice.name]: bgLeadSlice.reducer,
	[bgSignatorySlice.name]: bgSignatorySlice.reducer,
})
